import { NodeViewWrapper } from '@tiptap/react';
import React from 'react';
import { Chip, createUseStyles, useClasses } from '@Sage/hoi-poi-ui';
import classnames from 'classnames';
import styles from "./styles";
const useStyles = createUseStyles(styles, 'VariableRichText');
export default _ref => {
  var _extension$options, _extension$options$va;
  let {
    node,
    extension
  } = _ref;
  const classes = useClasses(useStyles);
  const variable = extension === null || extension === void 0 ? void 0 : (_extension$options = extension.options) === null || _extension$options === void 0 ? void 0 : (_extension$options$va = _extension$options.variableMap) === null || _extension$options$va === void 0 ? void 0 : _extension$options$va[node.attrs.key];
  if (!variable) return null;
  return /*#__PURE__*/React.createElement(NodeViewWrapper, {
    className: classnames('fm-richtext__variable', classes.root)
  }, /*#__PURE__*/React.createElement(Chip, {
    icon: variable === null || variable === void 0 ? void 0 : variable.icon,
    isActive: true,
    className: classes.chip
  }, variable === null || variable === void 0 ? void 0 : variable.label));
};